import { dequal } from 'dequal';
import memoize from 'memoize-one';
export const dotGet = memoize((obj, path, defValue) => {
  // If path is not defined or it has false value
  if (!path) return undefined;
  // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
  // Regex explained: https://regexr.com/58j0k
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  if (pathArray) {
    return pathArray.reduce((prevObj, key) => prevObj && prevObj[key], obj);
  }
  return defValue;
}, dequal);
export const copyObject = obj => JSON.parse(JSON.stringify(obj));